/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './startPhoneVerification.defs.js'
export { main as default } from './startPhoneVerification.defs.js'
